import React from "react";
import Casestudies from "./components/Casestudies";

export default function Work() {
  return (
    <>
      <Casestudies />
    </>
  );
}
